/*
 * Kleuren op het scherm (15-10-2026). Letterlijk overgenomen uit Caroliens websiteontwerp v3.7 (het spel Kleuren):
 * een plaat kiezen, 12 of 48 kleuren, vlakken vullen tot aan de lijnen, drie kwasten, een gum, opnieuw beginnen en je
 * plaat bewaren. De lijntekeningen komen uit het thema (km-kp-<sleutel>.jpg, dezelfde als bij de kleurplaten om te printen).
 * Werkt per sectie: alles wordt binnen [data-kleurboek] gezocht, er zijn geen vaste id's.
 * 22-10-2026: een plaat kan zijn eigen kleuren meebrengen (de kleuren uit Caroliens gekleurde tekening, rij Kleuren uit de
 * tekening), en een kind maakt met de kleurenkiezer zijn eigen kleuren. Die komen in Mijn kleuren en blijven op dit apparaat.
 * Daarna, op Caroliens ontwerp: drie rijen kleuren onder de tekening. Rij 1 de kleuren van de tekening (anders de gewone
 * 12) met wit en zwart, rij 2 extra kleuren, rij 3 de regenboogknop en Mijn kleuren. Geen keuze meer tussen 12 en 48.
 * Later die dag: rij 1 vult zich aan tot hij vol is, en een vergrootglas om kleine stukjes in te kleuren.
 */
(function () {
  "use strict";
  /* rij 2: extra kleuren naast die van de tekening (22-10-2026) */
  var EXTRA = ["#E8437E","#F9B8CE","#F0721F","#FFD800","#8FBF6F","#2F7F52","#5BC6F2","#2E6E8E","#1B4A62","#8E6E9E","#B32B5C","#B0663A","#F7C8A0","#B4B4B4"];
  var VERF12 = ["#E8437E","#F0721F","#FFD800","#8FBF6F","#5FB07A","#5BC6F2","#2E6E8E","#95ACDA","#B0663A","#8E6E9E","#F7C8A0","#3A3A38"];
  /* Haar lijntekeningen hebben dunne lijnen; na het verkleinen worden die lichtgrijs en krijgen ze gaatjes. Daarom telt
     ook lichtgrijs als lijn en wordt elke lijn een pixel dikker gemaakt, zodat de verf niet doorloopt. */
  var MUURDREMPEL = 225;
  /* Het kleurvlak is 1800 pixels breed (was 900, 22-10-2026): op 900 vielen kleine stukjes zoals de zeester in losse
     stukjes uiteen, omdat haar lijnen daar te dicht op elkaar komen. De kwasten zijn gemeten op 900 en schalen mee. */
  var BREED = 1800;
  /* Mijn kleuren: de nieuwste vooraan, hooguit dertien (de rij heeft veertien plekken, de eerste is de regenboogknop),
     alleen op dit apparaat bewaard. */
  var MIJN_SLEUTEL = "km-kleurboek-mijn-kleuren", MIJN_MAX = 13;
  function hexRgb(h) { return [parseInt(h.substr(1, 2), 16), parseInt(h.substr(3, 2), 16), parseInt(h.substr(5, 2), 16)]; }
  /* Op Caroliens verzoek (22-10-2026) staan de kleuren in elke rij van licht naar donker, gemeten zoals het oog licht weegt. */
  function helderheid(h) { var k = hexRgb(h); return k[0] * 0.299 + k[1] * 0.587 + k[2] * 0.114; }
  function lichtNaarDonker(lijst) { return lijst.slice().sort(function (a, b) { return helderheid(b) - helderheid(a); }); }
  function hslHex(h, s, l) {
    s /= 100; l /= 100;
    var a = s * Math.min(l, 1 - l);
    function f(n) { var k = (n + h / 30) % 12; return Math.round(255 * (l - a * Math.max(-1, Math.min(k - 3, 9 - k, 1)))); }
    return "#" + [f(0), f(8), f(4)].map(function (x) { return ("0" + x.toString(16)).slice(-2); }).join("").toUpperCase();
  }
  /* Kleurcodes uit een tekst halen, bijvoorbeeld "#D1DCEF, #E8CE85". Alles wat geen kleurcode is valt weg. */
  function leesKleuren(tekst) {
    return String(tekst || "").split(/[\s,;]+/).filter(function (k) { return /^#[0-9a-f]{6}$/i.test(k); }).map(function (k) { return k.toUpperCase(); });
  }
  function leesMijn() { try { return leesKleuren((JSON.parse(localStorage.getItem(MIJN_SLEUTEL)) || []).join(",")).slice(0, MIJN_MAX); } catch (e) { return []; } }
  function bewaarMijn(lijst) { try { localStorage.setItem(MIJN_SLEUTEL, JSON.stringify(lijst)); } catch (e) {} }

  function start(root) {
    var PLATEN = []; try { PLATEN = JSON.parse(root.querySelector('[data-platen]').textContent); } catch (e) {}
    if (!PLATEN.length) return;
    PLATEN.forEach(function (pl) {
      pl.kleuren = leesKleuren(pl.kleuren);
      /* punten in dieren die in een keer kleuren, als "x,y; x,y" (deel van de breedte en hoogte, 0 tot 1) */
      pl.dieren = leesPunten(pl.dieren);
      /* punten in piepkleine vlakjes die toch apart moeten blijven (zie maakAanhang) */
      pl.apart = leesPunten(pl.apart);
    });
    function leesPunten(tekst) {
      return String(tekst || "").split(";").map(function (d) { return d.split(",").map(Number); })
        .filter(function (d) { return d.length === 2 && d.every(function (v) { return v >= 0 && v <= 1; }); });
    }
    var kleurKleur = VERF12[5], kwast = 30, gereedschap = "vul", plaatNu = 0, tekenen = false, ctx = null;
    var MIJN = leesMijn();
    var masker = null, vlak = null, maskerW = 0, maskerH = 0;
    var c = root.querySelector('canvas'), lijnen = root.querySelector('.kb-lijnen'), hint = root.querySelector('.kb-hint');
    var keuze = root.querySelector('.kb-keuze'), bak = root.querySelector('[data-kb-verf]');
    var voorbeeld = root.querySelector('[data-kb-voorbeeld]'), popup = root.querySelector('[data-kb-popup]');
    var kiezer = root.querySelector('[data-kb-kiezer]');
    /* de regenboogknop staat achteraan in de kleuren, voor Mijn kleuren */
    var plus = document.createElement("button"); plus.type = "button"; plus.className = "kb-plus";
    plus.setAttribute("aria-label", "Maak je eigen kleur"); plus.setAttribute("aria-expanded", "false");

    /* grens: de onzichtbare grenzen van de plaat (km-kp-<sleutel>-vlakken.svg), zwart op wit. Die komen uit Caroliens
       gekleurde tekening, op plekken waar de kleur verspringt maar geen lijn staat, zoals de bovenkant van het oor van Mup. */
    function maakMasker(beeld, w, h, grens, apart) {
      var hulp = document.createElement("canvas"); hulp.width = w; hulp.height = h;
      var hx = hulp.getContext("2d", { willReadFrequently: true });
      hx.fillStyle = "#fff"; hx.fillRect(0, 0, w, h); hx.drawImage(beeld, 0, 0, w, h);
      if (grens) { hx.globalCompositeOperation = "multiply"; hx.drawImage(grens, 0, 0, w, h); hx.globalCompositeOperation = "source-over"; }
      var d = hx.getImageData(0, 0, w, h).data, m = new Uint8Array(w * h);
      for (var i = 0, j = 0; i < m.length; i++, j += 4) {
        /* grijswaarde volgens hoe het oog licht weegt */
        if ((d[j] * 0.299 + d[j + 1] * 0.587 + d[j + 2] * 0.114) < MUURDREMPEL) m[i] = 1;
      }
      var ruw = m;
      /* elke lijn een pixel dikker */
      for (var r = 0; r < 1; r++) {
        var n = new Uint8Array(m);
        for (var y = 1; y < h - 1; y++) for (var x = 1; x < w - 1; x++) {
          var k = y * w + x;
          if (!m[k] && (m[k - 1] || m[k + 1] || m[k - w] || m[k + w])) n[k] = 1;
        }
        m = n;
      }
      masker = m; maskerW = w; maskerH = h;
      maakVlakken(w, h);
      maakAanhang(ruw, apart || [], w, h);
    }
    /* Elk vlak tussen de lijnen krijgt een nummer, en elke lijnpixel hoort bij het vlak dat er het dichtst bij ligt
       (eerst alle vlakken, dan stap voor stap tegelijk de lijnen in). Zo weet de emmer welke stukjes onder en naast
       de lijn bij zijn vlak horen, en komt de kleur nooit aan de andere kant van een lijn. */
    function maakVlakken(w, h) {
      var v = new Int32Array(w * h), rij = new Int32Array(w * h), kop = 0, staart = 0, nr = 0;
      for (var s = 0; s < v.length; s++) {
        if (masker[s] || v[s]) continue;
        nr++; v[s] = nr; var stapel = [s];
        while (stapel.length) {
          var i = stapel.pop(), x = i % w;
          rij[staart++] = i;
          if (x > 0 && !masker[i - 1] && !v[i - 1]) { v[i - 1] = nr; stapel.push(i - 1); }
          if (x < w - 1 && !masker[i + 1] && !v[i + 1]) { v[i + 1] = nr; stapel.push(i + 1); }
          if (i >= w && !masker[i - w] && !v[i - w]) { v[i - w] = nr; stapel.push(i - w); }
          if (i < v.length - w && !masker[i + w] && !v[i + w]) { v[i + w] = nr; stapel.push(i + w); }
        }
      }
      while (kop < staart) {
        var j = rij[kop++], jx = j % w, buren = [jx > 0 ? j - 1 : -1, jx < w - 1 ? j + 1 : -1, j >= w ? j - w : -1, j < v.length - w ? j + w : -1];
        for (var b = 0; b < 4; b++) { var n = buren[b]; if (n > -1 && !v[n]) { v[n] = v[j]; rij[staart++] = n; } }
      }
      vlak = v;
    }
    /* Piepkleine en flinterdunne vlakjes kleuren mee met hun buurvlak (Carolien, 22-10-2026: "Het zeilbootje inkleuren
       gaat nog niet goed", "de randen van de slippers ook", "bij het zandkasteel bij de zwembroek"). Waar twee lijnen bijna
       tegen elkaar komen blijft anders een snippertje wit over dat je niet kunt aantikken: het dopje van de mast, het puntje
       van de rand van een slipper, het stukje tussen de touwtjes van de zwembroek. Zo'n vlakje hoort bij het vlak waar het
       vast zou zitten als de lijnen niet verdikt waren, en anders bij het vlak waar het het langst aan grenst. Vlakjes in
       een klein los getekend vormpje (een oog, een rondje) blijven apart, net als de vlakjes bij de punten in apart.
       aanhang[i] zegt dat pixel i zo'n meegenomen vlakje is; vlak[i] is dan al het nummer van het buurvlak. */
    var aanhang = null;
    function maakAanhang(ruw, punten, w, h) {
      var n = w * h, i, k, hoogste = 0;
      aanhang = new Uint8Array(n);
      for (i = 0; i < n; i++) if (vlak[i] > hoogste) hoogste = vlak[i];
      /* per vlak: hoeveel pixels, en hoe ver het verst van een lijn af ligt (in stapjes) */
      var af = new Uint16Array(n);
      for (i = 0; i < n; i++) af[i] = masker[i] ? 0 : 65535;
      for (i = 0; i < n; i++) if (af[i]) {
        if (i % w > 0 && af[i - 1] + 1 < af[i]) af[i] = af[i - 1] + 1;
        if (i >= w && af[i - w] + 1 < af[i]) af[i] = af[i - w] + 1;
      }
      for (i = n - 1; i >= 0; i--) if (af[i]) {
        if (i % w < w - 1 && af[i + 1] + 1 < af[i]) af[i] = af[i + 1] + 1;
        if (i < n - w && af[i + w] + 1 < af[i]) af[i] = af[i + w] + 1;
      }
      var maat = new Int32Array(hoogste + 1), dik = new Uint16Array(hoogste + 1);
      for (i = 0; i < n; i++) if (!masker[i]) { maat[vlak[i]]++; if (af[i] > dik[vlak[i]]) dik[vlak[i]] = af[i]; }
      var snipper = new Uint8Array(hoogste + 1), aantal = 0;
      for (k = 1; k <= hoogste; k++) if (maat[k] && (maat[k] < 40 || (dik[k] <= 2 && maat[k] < 300))) { snipper[k] = 1; aantal++; }
      if (!aantal) return;
      punten.forEach(function (pt) {
        var j = Math.round(pt[1] * h) * w + Math.round(pt[0] * w);
        if (j >= 0 && j < n && !masker[j]) snipper[vlak[j]] = 0;
      });
      /* de lijnen in losse stukken; een stuk dat nergens 40 pixels lang of hoog is, is een los getekend vormpje */
      var stuk = new Int32Array(n), stukGroot = [0], s = 0, stapel = [];
      for (i = 0; i < n; i++) {
        if (!masker[i] || stuk[i]) continue;
        s++; stuk[i] = s; stapel.push(i);
        var x0 = w, x1 = 0, y0 = h, y1 = 0;
        while (stapel.length) {
          var p = stapel.pop(), px = p % w, py = (p / w) | 0;
          if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py;
          if (px > 0 && masker[p - 1] && !stuk[p - 1]) { stuk[p - 1] = s; stapel.push(p - 1); }
          if (px < w - 1 && masker[p + 1] && !stuk[p + 1]) { stuk[p + 1] = s; stapel.push(p + 1); }
          if (p >= w && masker[p - w] && !stuk[p - w]) { stuk[p - w] = s; stapel.push(p - w); }
          if (p < n - w && masker[p + w] && !stuk[p + w]) { stuk[p + w] = s; stapel.push(p + w); }
        }
        stukGroot[s] = Math.max(x1 - x0, y1 - y0) + 1 >= 40;
      }
      var aanGroot = new Uint8Array(hoogste + 1);
      for (i = 0; i < n; i++) {
        if (masker[i] || !snipper[vlak[i]]) continue;
        var x = i % w;
        if ((x > 0 && masker[i - 1] && stukGroot[stuk[i - 1]]) || (x < w - 1 && masker[i + 1] && stukGroot[stuk[i + 1]]) ||
            (i >= w && masker[i - w] && stukGroot[stuk[i - w]]) || (i < n - w && masker[i + w] && stukGroot[stuk[i + w]])) aanGroot[vlak[i]] = 1;
      }
      for (k = 1; k <= hoogste; k++) if (!aanGroot[k]) snipper[k] = 0;
      /* Bij welk buurvlak hoort een snippertje? Kanshebbers zijn de vlakken waar het aan vast zou zitten als de lijnen niet
         verdikt waren (ruw is de lijn zonder verdikking), en de vlakken waar het flink aan grenst: minstens een kwart van
         de langste grens, langs de lijnen zoals maakVlakken ze verdeelde. Van de kanshebbers wint het kleinste, want een
         snippertje hoort eerder bij de band van de zwembroek of de mast dan bij de buik of de lucht. */
      var kans = {}, ruwVlak = new Int32Array(n), r = 0;
      for (i = 0; i < n; i++) {
        if (ruw[i] || ruwVlak[i]) continue;
        r++; ruwVlak[i] = r; stapel.push(i);
        var leden = [], heeftSnipper = false;
        while (stapel.length) {
          var q = stapel.pop(), qx = q % w; leden.push(q);
          if (!masker[q] && snipper[vlak[q]]) heeftSnipper = true;
          if (qx > 0 && !ruw[q - 1] && !ruwVlak[q - 1]) { ruwVlak[q - 1] = r; stapel.push(q - 1); }
          if (qx < w - 1 && !ruw[q + 1] && !ruwVlak[q + 1]) { ruwVlak[q + 1] = r; stapel.push(q + 1); }
          if (q >= w && !ruw[q - w] && !ruwVlak[q - w]) { ruwVlak[q - w] = r; stapel.push(q - w); }
          if (q < n - w && !ruw[q + w] && !ruwVlak[q + w]) { ruwVlak[q + w] = r; stapel.push(q + w); }
        }
        if (!heeftSnipper) continue;
        var gewoon = {}, snippers = {};
        leden.forEach(function (q) { if (!masker[q]) { if (snipper[vlak[q]]) snippers[vlak[q]] = 1; else gewoon[vlak[q]] = 1; } });
        Object.keys(snippers).forEach(function (a) { var kv = kans[a] = kans[a] || {}; Object.keys(gewoon).forEach(function (b) { kv[b] = 1; }); });
      }
      var grens = {};
      function tel(a, b) { if (a !== b && snipper[a]) { var g = grens[a] = grens[a] || {}; g[b] = (g[b] || 0) + 1; } }
      for (i = 0; i < n; i++) {
        if (i % w < w - 1) { tel(vlak[i], vlak[i + 1]); tel(vlak[i + 1], vlak[i]); }
        if (i < n - w) { tel(vlak[i], vlak[i + w]); tel(vlak[i + w], vlak[i]); }
      }
      var doel = {};
      Object.keys(grens).forEach(function (a) {
        var g = grens[a], kv = kans[a] = kans[a] || {}, langst = 0, b;
        for (b in g) if (!snipper[b] && g[b] > langst) langst = g[b];
        for (b in g) if (!snipper[b] && g[b] >= langst / 4) kv[b] = 1;
        var beste = 0;
        for (b in kv) if (!beste || maat[b] < maat[beste]) beste = +b;
        /* alleen snippertjes ernaast: dan bij het snippertje waar het het langst aan grenst, en verder doorlopen */
        if (!beste) { var lang = 0; for (b in g) if (g[b] > lang) { lang = g[b]; beste = +b; } }
        if (beste) doel[a] = beste;
      });
      /* een snipper naast een snipper: doorlopen tot een gewoon vlak */
      var eind = {};
      Object.keys(doel).forEach(function (a) {
        var t = doel[a], stap = 0;
        while (snipper[t] && doel[t] !== undefined && stap++ < 20) t = doel[t];
        if (!snipper[t]) eind[a] = t;
      });
      for (i = 0; i < n; i++) {
        var e = eind[vlak[i]];
        if (e === undefined) continue;
        if (!masker[i]) aanhang[i] = 1;
        vlak[i] = e;
      }
    }
    /* Hele dieren in een keer (Carolien, 22-10-2026: "Als je de krab aanklikt kan je dan de hele krab die kleur geven",
       "de ogen en de mond dan niet", "die mogen dan een andere kleur worden als je deze aantikt"). Per plaat staan er
       punten in het dier. Vanaf zo'n punt naar links tot de lijn die er helemaal omheen loopt (de omtrek van het dier, met
       de poten); alles daarbinnen hoort bij het dier, behalve vlakjes die alleen aan het lijf grenzen (ogen, mond).
       Lijnpixels aan de buitenkant die bij het zand horen doen niet mee, anders komt er een randje kleur op het zand. */
    var dieren = [], dierVan = {};
    /* de omhullende van een stel punten (zoals een elastiekje eromheen), en of een punt erbinnen ligt */
    function omhullende(p) {
      p = p.slice().sort(function (a, b) { return a[0] - b[0] || a[1] - b[1]; });
      if (p.length < 3) return p;
      function kruis(o, a, b) { return (a[0] - o[0]) * (b[1] - o[1]) - (a[1] - o[1]) * (b[0] - o[0]); }
      var onder = [], boven = [], i;
      for (i = 0; i < p.length; i++) { while (onder.length >= 2 && kruis(onder[onder.length - 2], onder[onder.length - 1], p[i]) <= 0) onder.pop(); onder.push(p[i]); }
      for (i = p.length - 1; i >= 0; i--) { while (boven.length >= 2 && kruis(boven[boven.length - 2], boven[boven.length - 1], p[i]) <= 0) boven.pop(); boven.push(p[i]); }
      return onder.slice(0, -1).concat(boven.slice(0, -1));
    }
    function inRomp(romp, x, y) {
      if (romp.length < 3) return false;
      for (var i = 0; i < romp.length; i++) {
        var a = romp[i], b = romp[(i + 1) % romp.length];
        if ((b[0] - a[0]) * (y - a[1]) - (b[1] - a[1]) * (x - a[0]) < 0) return false;
      }
      return true;
    }
    function maakDieren(punten, w, h) {
      dieren = []; dierVan = {};
      if (!punten.length) return;
      var hoogste = 0, i;
      for (i = 0; i < vlak.length; i++) if (vlak[i] > hoogste) hoogste = vlak[i];
      var maat = new Int32Array(hoogste + 1);
      for (i = 0; i < vlak.length; i++) if (!masker[i]) maat[vlak[i]]++;
      var grootGrens = 0.04 * w * h, bezocht = new Uint8Array(w * h);
      punten.forEach(function (pt) {
        var x = Math.round(pt[0] * w), y = Math.round(pt[1] * h);
        if (x < 0 || y < 0 || x >= w || y >= h) return;
        var zaad = y * w + x, start = vlak[zaad];
        for (var xx = x; xx >= 0; xx--) {
          var k = y * w + xx;
          if (!masker[k] || bezocht[k]) continue;
          /* de lijn die hier begint, met zijn omsluitende rechthoek */
          var lijn = [k], x0 = xx, x1 = xx, y0 = y, y1 = y; bezocht[k] = 1;
          for (var q = 0; q < lijn.length; q++) {
            var p = lijn[q], px = p % w, py = (p / w) | 0;
            if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py;
            [px > 0 ? p - 1 : -1, px < w - 1 ? p + 1 : -1, p >= w ? p - w : -1, p < w * h - w ? p + w : -1].forEach(function (n) {
              if (n > -1 && masker[n] && !bezocht[n]) { bezocht[n] = 1; lijn.push(n); }
            });
          }
          if (x < x0 || x > x1 || y < y0 || y > y1 || lijn.length > grootGrens) continue;
          /* loopt de lijn om het punt heen? dan is alles wat je van buiten de rechthoek niet kunt bereiken het dier */
          var bw = x1 - x0 + 3, bh = y1 - y0 + 3, op = new Uint8Array(bw * bh), buiten = new Uint8Array(bw * bh), rij = [0];
          lijn.forEach(function (p) { op[((p / w | 0) - y0 + 1) * bw + (p % w - x0 + 1)] = 1; });
          buiten[0] = 1;
          for (var r = 0; r < rij.length; r++) {
            var b = rij[r], bx = b % bw;
            [bx > 0 ? b - 1 : -1, bx < bw - 1 ? b + 1 : -1, b >= bw ? b - bw : -1, b < bw * bh - bw ? b + bw : -1].forEach(function (n) {
              if (n > -1 && !buiten[n] && !op[n]) { buiten[n] = 1; rij.push(n); }
            });
          }
          if (buiten[(y - y0 + 1) * bw + (x - x0 + 1)]) continue;
          /* gevonden: de pixels van het dier, de buren van elk vlak erin, en welke vlakjes ogen en mond zijn */
          var pix = [], buren = {}, nr = dieren.length;
          for (var by = 1; by < bh - 1; by++) for (var bx2 = 1; bx2 < bw - 1; bx2++) {
            if (buiten[by * bw + bx2]) continue;
            var j = (by - 1 + y0) * w + (bx2 - 1 + x0); pix.push(j);
            var vj = vlak[j];
            [j + 1, j + w].forEach(function (n) {
              if (n < w * h && vlak[n] !== vj) { (buren[vj] = buren[vj] || {})[vlak[n]] = 1; (buren[vlak[n]] = buren[vlak[n]] || {})[vj] = 1; }
            });
          }
          /* Ogen en mond blijven apart (Carolien, 22-10-2026: "als ik nu op de krab klik dan worden de ogen ook oranje"):
             vlakjes die nergens aan iets buiten het dier grenzen en voor het grootste deel binnen de omtrek van het lijf
             liggen (de omhullende van het lijf, zodat een stukje poot er niet onder valt). */
          var inDier = {}, randen = [];
          pix.forEach(function (j) { if (!masker[j]) inDier[vlak[j]] = 1; });
          for (var ry = y0; ry <= y1; ry++) {
            var lo = -1, hi = -1;
            for (var rx = x0; rx <= x1; rx++) { if (vlak[ry * w + rx] === start && !masker[ry * w + rx]) { if (lo < 0) lo = rx; hi = rx; } }
            if (lo >= 0) { randen.push([lo, ry]); if (hi !== lo) randen.push([hi, ry]); }
          }
          var romp = omhullende(randen);
          var apart = {};
          Object.keys(inDier).forEach(function (v) {
            if (+v === start || !buren[v]) return;
            if (Object.keys(buren[v]).some(function (b2) { return !inDier[b2]; })) return;
            var binnen = 0, alle = 0;
            pix.forEach(function (j) { if (vlak[j] === +v && !masker[j]) { alle++; if (inRomp(romp, j % w, (j / w) | 0)) binnen++; } });
            if (alle && binnen / alle > 0.5) apart[v] = 1;
          });
          var kleuren = pix.filter(function (j) { return !apart[vlak[j]] && !(masker[j] && maat[vlak[j]] > grootGrens); });
          dieren.push(new Int32Array(kleuren));
          kleuren.forEach(function (j) { if (!masker[j]) dierVan[vlak[j]] = nr; });
          return;
        }
      });
    }
    /* Vult alles wat aan elkaar vastzit en dezelfde kleur heeft, tot aan de lijnen. */
    function vulVlak(px, py) {
      var w = c.width, h = c.height;
      px = Math.round(px); py = Math.round(py);
      if (px < 0 || py < 0 || px >= w || py >= h) return;
      if (!masker || maskerW !== w || maskerH !== h) return;
      var startIdx = py * w + px;
      /* Net op een lijn getikt (in het vergrootglas gebeurt dat snel bij een smal stukje): dan het vlak waar die lijn bij
         hoort, vanaf het dichtstbijzijnde puntje ervan. */
      if (masker[startIdx]) {
        var lijnVlak = vlak[startIdx], dichtst = -1, afstand = 1e9;
        for (var zy = Math.max(0, py - 10); zy <= Math.min(h - 1, py + 10); zy++) {
          for (var zx = Math.max(0, px - 10); zx <= Math.min(w - 1, px + 10); zx++) {
            var zj = zy * w + zx, za = (zx - px) * (zx - px) + (zy - py) * (zy - py);
            if (!masker[zj] && vlak[zj] === lijnVlak && za < afstand) { afstand = za; dichtst = zj; }
          }
        }
        if (dichtst < 0) return;
        startIdx = dichtst;
      }
      /* getikt in een snippertje dat met een buurvlak meekleurt (zie maakAanhang): dan dat buurvlak */
      if (aanhang && aanhang[startIdx]) {
        for (var ai = 0; ai < masker.length; ai++) if (!masker[ai] && !aanhang[ai] && vlak[ai] === vlak[startIdx]) { startIdx = ai; break; }
      }
      var beeld = ctx.getImageData(0, 0, w, h), p = beeld.data;
      /* tik in een dier dat in een keer kleurt (zie maakDieren): het hele dier in deze kleur */
      var dier = dierVan[vlak[startIdx]];
      if (dier !== undefined) {
        var kl = gereedschap === "gum" ? [255, 255, 255] : hexRgb(kleurKleur);
        dieren[dier].forEach(function (j) { var q = j * 4; p[q] = kl[0]; p[q + 1] = kl[1]; p[q + 2] = kl[2]; p[q + 3] = 255; });
        ctx.putImageData(beeld, 0, 0); return;
      }
      var sr = p[startIdx * 4], sg = p[startIdx * 4 + 1], sb = p[startIdx * 4 + 2];
      var nieuw = gereedschap === "gum" ? [255, 255, 255] : hexRgb(kleurKleur);
      if (sr === nieuw[0] && sg === nieuw[1] && sb === nieuw[2]) return;
      var gezien = new Uint8Array(w * h);
      function mag(j) { if (masker[j] || gezien[j]) return false; var q = j * 4; return p[q] === sr && p[q + 1] === sg && p[q + 2] === sb; }
      var stapel = [startIdx]; gezien[startIdx] = 1;
      while (stapel.length) {
        var i = stapel.pop(), y = (i / w) | 0, links = i - y * w, rechts = links;
        while (links > 0 && mag(y * w + links - 1)) { links--; gezien[y * w + links] = 1; }
        while (rechts < w - 1 && mag(y * w + rechts + 1)) { rechts++; gezien[y * w + rechts] = 1; }
        for (var x = links; x <= rechts; x++) {
          var j = y * w + x, q = j * 4; gezien[j] = 1;
          p[q] = nieuw[0]; p[q + 1] = nieuw[1]; p[q + 2] = nieuw[2]; p[q + 3] = 255;
          if (y > 0 && mag(j - w)) { gezien[j - w] = 1; stapel.push(j - w); }
          if (y < h - 1 && mag(j + w)) { gezien[j + w] = 1; stapel.push(j + w); }
        }
      }
      /* Ook onder de lijnen en in de smalle hoekjes kleuren (22-10-2026), anders bleef er langs elke lijn een wit randje
         over: de lijnen zijn een pixel verdikt en hun zachte randen lichtgrijs. Alleen lijnpixels die bij dit vlak horen
         (zie maakVlakken), en hooguit twaalf stapjes vanaf de verf, zodat een stuk dat met de kwast al een andere kleur
         kreeg niet ineens een gekleurd randje krijgt. De lijntekening ligt er bovenop, dus onder het zwart zie je niets. */
      var eigenVlak = vlak[startIdx], rand = [];
      /* de snippertjes die bij dit vlak horen en nog dezelfde kleur hebben, kleuren mee (zie maakAanhang) */
      for (var si = 0; si < masker.length; si++) {
        if (!aanhang[si] || gezien[si] || vlak[si] !== eigenVlak) continue;
        var sq = si * 4;
        if (p[sq] !== sr || p[sq + 1] !== sg || p[sq + 2] !== sb) continue;
        gezien[si] = 1; p[sq] = nieuw[0]; p[sq + 1] = nieuw[1]; p[sq + 2] = nieuw[2]; p[sq + 3] = 255;
      }
      for (var ri = 0; ri < masker.length; ri++) {
        if (!masker[ri] || vlak[ri] !== eigenVlak) continue;
        var rx = ri % w;
        if ((rx > 0 && gezien[ri - 1]) || (rx < w - 1 && gezien[ri + 1]) || (ri >= w && gezien[ri - w]) || (ri < masker.length - w && gezien[ri + w])) rand.push(ri);
      }
      for (var stap = 0; stap < 12 && rand.length; stap++) {
        var volgende = [];
        rand.forEach(function (rj) {
          if (gezien[rj]) return;
          var rq = rj * 4; gezien[rj] = 1; p[rq] = nieuw[0]; p[rq + 1] = nieuw[1]; p[rq + 2] = nieuw[2]; p[rq + 3] = 255;
          var bx = rj % w;
          [bx > 0 ? rj - 1 : -1, bx < w - 1 ? rj + 1 : -1, rj >= w ? rj - w : -1, rj < masker.length - w ? rj + w : -1].forEach(function (n) {
            if (n > -1 && masker[n] && !gezien[n] && vlak[n] === eigenVlak) volgende.push(n);
          });
        });
        rand = volgende;
      }
      ctx.putImageData(beeld, 0, 0);
    }
    function kiesKleur(k) { kleurKleur = k; if (gereedschap === "gum") kiesGereedschap("vul"); markeer(); }
    /* --verf kleurt ook de icoontjes van de emmer en de kwasten mee */
    function markeer() {
      root.style.setProperty("--verf", kleurKleur);
      root.querySelectorAll(".kb-verf button[data-kleur]").forEach(function (x) { x.setAttribute("aria-current", x.dataset.kleur === kleurKleur ? "true" : "false"); });
    }
    function verfKnop(k, doel, uitleg) {
      var b = document.createElement("button"); b.type = "button"; b.style.background = k; b.dataset.kleur = k; b.setAttribute("aria-label", uitleg + " " + k);
      b.onclick = function () { kiesKleur(k); };
      doel.appendChild(b);
    }
    /* Rij 1: de kleuren uit de tekening (heeft de plaat ze niet, dan de gewone 12), altijd met wit en zwart erbij.
       Heeft de tekening er minder dan twaalf, dan vult de rij zich aan met kleuren uit de andere tekeningen die er niet
       te veel op lijken (Carolien, 22-10-2026: "zodat deze rij vol is ... met willekeurige kleuren uit andere tekeningen"). */
    function lijktOp(k, lijst) {
      var a = hexRgb(k);
      return lijst.some(function (m) { var b = hexRgb(m); return Math.abs(a[0] - b[0]) + Math.abs(a[1] - b[1]) + Math.abs(a[2] - b[2]) < 60; });
    }
    function verf() {
      var eigen = PLATEN[plaatNu].kleuren, rij = (eigen.length ? eigen : VERF12).slice();
      for (var a = 1; eigen.length && a < PLATEN.length && rij.length < 12; a++) {
        PLATEN[(plaatNu + a) % PLATEN.length].kleuren.forEach(function (k) {
          if (rij.length < 12 && !lijktOp(k, rij.concat(["#FFFFFF", "#000000"]))) rij.push(k);
        });
      }
      ["#FFFFFF", "#000000"].forEach(function (k) { if (rij.indexOf(k) < 0) rij.push(k); });
      return rij;
    }
    /* Drie rijen onder de tekening, elk van licht naar donker: de tekening, extra kleuren (zonder dubbele), en de
       regenboogknop met Mijn kleuren (de nieuwste vooraan). */
    function verfTeken() {
      var eerste = verf(), tweede = EXTRA.filter(function (k) { return eerste.indexOf(k) < 0; });
      bak.innerHTML = "";
      [lichtNaarDonker(eerste), lichtNaarDonker(tweede), null].forEach(function (lijst) {
        var rij = document.createElement("div"); rij.className = "kb-kleurrij"; bak.appendChild(rij);
        if (lijst) { lijst.forEach(function (k) { verfKnop(k, rij, "Kleur"); }); return; }
        rij.appendChild(plus);
        MIJN.forEach(function (k) { verfKnop(k, rij, "Mijn kleur"); });
      });
      markeer();
    }
    function kiesGereedschap(waarde) {
      gereedschap = waarde === "gum" ? "gum" : (waarde === "vul" ? "vul" : "kwast");
      if (gereedschap === "kwast") kwast = +waarde;
      root.querySelectorAll(".kb-kwasten [data-kwast]").forEach(function (x) { x.setAttribute("aria-current", x.dataset.kwast === waarde ? "true" : "false"); });
      hint.textContent = gereedschap === "vul" ? "Tik op een vlak om het te vullen" : gereedschap === "gum" ? "Veeg over je fout, dan gaat hij weg" : "Sleep met je vinger of de muis";
    }
    /* Wat je op een plaat gekleurd hebt blijft bewaard zolang de pagina openstaat (Carolien, 22-10-2026: "Als je op een
       andere kleurplaat klikt is hetgeen wat je getekend had weg"). Kom je terug op de plaat, dan staat je kleurwerk er
       weer; Opnieuw maakt hem echt leeg. */
    var werk = {}, geladen = -1;
    function bewaarWerk() {
      /* alleen als de plaat op het doek ook echt de gekozen plaat is (niet halverwege het laden van een andere) */
      if (!ctx || geladen !== plaatNu) return;
      var kopie = document.createElement("canvas"); kopie.width = c.width; kopie.height = c.height;
      kopie.getContext("2d").drawImage(c, 0, 0); werk[plaatNu] = kopie;
    }
    function laad() {
      var pl = PLATEN[plaatNu]; lijnen.src = pl.groot; geladen = -1; terugKnop.disabled = true;
      keuze.querySelectorAll("button").forEach(function (b, i) { b.setAttribute("aria-current", i === plaatNu ? "true" : "false"); });
      /* de lijntekening en (als de plaat ze heeft) de onzichtbare grenzen; het masker pas maken als ze er allebei zijn */
      var im = new Image(), grens = null, nogTeLaden = pl.vlakken ? 2 : 1;
      function klaar() {
        if (--nogTeLaden || plaatNu !== PLATEN.indexOf(pl)) return;
        c.width = BREED; c.height = Math.round(BREED * im.height / im.width);
        ctx = c.getContext("2d", { willReadFrequently: true });
        ctx.fillStyle = "#ffffff"; ctx.fillRect(0, 0, c.width, c.height);
        if (werk[plaatNu]) ctx.drawImage(werk[plaatNu], 0, 0);
        maakMasker(im, c.width, c.height, grens, pl.apart);
        maakDieren(pl.dieren, c.width, c.height);
        lijnBeeld = im; geladen = plaatNu; zetTerug(); loepTeken();
      }
      im.onload = klaar;
      if (pl.vlakken) { grens = new Image(); grens.onload = klaar; grens.onerror = function () { grens = null; klaar(); }; grens.src = pl.vlakken; }
      im.src = pl.groot;
      hint.textContent = "Je kleurt: " + pl.naam;
      /* het voorbeeld rechtsboven, alleen als de plaat er een heeft */
      voorbeeld.hidden = !pl.voorbeeld; popup.hidden = true;
      if (pl.voorbeeld) { voorbeeld.querySelector("img").src = pl.voorbeeld; popup.querySelector("img").src = pl.voorbeeld; }
      /* hoort de gekozen kleur niet bij deze plaat, dan een kleur uit het midden */
      var rij = lichtNaarDonker(verf());
      if (rij.indexOf(kleurKleur) < 0 && EXTRA.indexOf(kleurKleur) < 0 && MIJN.indexOf(kleurKleur) < 0) kleurKleur = rij[Math.floor(rij.length / 2)];
      verfTeken();
    }
    /* tik op het voorbeeld: groot in beeld; tik nog een keer (of Esc): weg */
    voorbeeld.onclick = function () { popup.hidden = false; popup.focus && popup.focus(); };
    popup.onclick = function () { popup.hidden = true; voorbeeld.focus(); };
    document.addEventListener("keydown", function (ev) { if (ev.key === "Escape" && !popup.hidden) popup.onclick(); });
    function bewaar() {
      var uit = document.createElement("canvas"); uit.width = c.width; uit.height = c.height;
      var x = uit.getContext("2d"); x.fillStyle = "#fff"; x.fillRect(0, 0, uit.width, uit.height); x.drawImage(c, 0, 0);
      var lijn = new Image();
      lijn.onload = function () {
        x.globalCompositeOperation = "multiply"; x.drawImage(lijn, 0, 0, uit.width, uit.height);
        x.globalCompositeOperation = "source-over";
        /* de handtekening rechtsonder, net als op het scherm: geel met een blauwe rand */
        var maat = Math.round(uit.width * 0.028), lettertype = "800 " + maat + "px 'Baloo 2', sans-serif";
        var klaar = function () {
          x.font = lettertype; x.textAlign = "right"; x.textBaseline = "alphabetic"; x.lineJoin = "round";
          var tx = uit.width - uit.width * 0.017, ty = uit.height - uit.width * 0.022;
          x.lineWidth = maat * 0.18; x.strokeStyle = "#2E6E8E"; x.strokeText("www.kaatjemup.nl", tx, ty);
          x.fillStyle = "#FCD800"; x.fillText("www.kaatjemup.nl", tx, ty);
          var a = document.createElement("a"); a.download = "mijn-kaatjemup-kleurplaat.png"; a.href = uit.toDataURL("image/png");
          document.body.appendChild(a); a.click(); a.remove();
        };
        if (document.fonts && document.fonts.load) document.fonts.load(lettertype).then(klaar, klaar); else klaar();
      };
      lijn.src = PLATEN[plaatNu].groot;
    }

    /* De kleurenkiezer: een regenboogstrook (met grijs aan het eind) en een strook van licht naar donker. Tikken of
       slepen kiest, het grote rondje laat zien wat je krijgt, en Deze wil ik! zet de kleur in Mijn kleuren. */
    var tintStrook = kiezer.querySelector('[data-strook="tint"]'), lichtStrook = kiezer.querySelector('[data-strook="licht"]');
    var proef = kiezer.querySelector('.kb-kiezer__proef'), tintPos = 0.55, lichtPos = 0.5;
    function tintVan(pos) { return pos > 0.9 ? null : Math.round(pos / 0.9 * 360) % 360; }
    function kiezerKleur(lichtWaarde) {
      var h = tintVan(tintPos), l = lichtWaarde === undefined ? Math.round(94 - lichtPos * 82) : lichtWaarde;
      return h === null ? hslHex(0, 0, l) : hslHex(h, 85, l);
    }
    function tekenKiezer() {
      var nu = kiezerKleur();
      tintStrook.firstElementChild.style.left = (tintPos * 100) + "%";
      tintStrook.firstElementChild.style.setProperty("--knop", kiezerKleur(53));
      lichtStrook.firstElementChild.style.left = (lichtPos * 100) + "%";
      lichtStrook.firstElementChild.style.setProperty("--knop", nu);
      lichtStrook.style.background = "linear-gradient(to right, " + kiezerKleur(94) + ", " + kiezerKleur(53) + ", " + kiezerKleur(12) + ")";
      proef.style.background = nu;
      tintStrook.setAttribute("aria-valuenow", Math.round(tintPos * 100));
      lichtStrook.setAttribute("aria-valuenow", Math.round(lichtPos * 100));
    }
    function sleepbaar(strook, lees, zet) {
      function naar(ev) { var r = strook.getBoundingClientRect(); zet(Math.max(0, Math.min(1, (ev.clientX - r.left) / r.width))); tekenKiezer(); }
      strook.addEventListener("pointerdown", function (ev) { ev.preventDefault(); strook.setPointerCapture(ev.pointerId); strook.dataset.sleept = "1"; naar(ev); });
      strook.addEventListener("pointermove", function (ev) { if (strook.dataset.sleept) naar(ev); });
      ["pointerup", "pointercancel"].forEach(function (t) { strook.addEventListener(t, function () { delete strook.dataset.sleept; }); });
      strook.addEventListener("keydown", function (ev) {
        var stap = { ArrowRight: .02, ArrowUp: .02, ArrowLeft: -.02, ArrowDown: -.02 }[ev.key];
        if (!stap) return;
        ev.preventDefault(); zet(Math.max(0, Math.min(1, lees() + stap))); tekenKiezer();
      });
    }
    sleepbaar(tintStrook, function () { return tintPos; }, function (v) { tintPos = v; });
    sleepbaar(lichtStrook, function () { return lichtPos; }, function (v) { lichtPos = v; });
    function kiezerDicht() { kiezer.hidden = true; plus.setAttribute("aria-expanded", "false"); plus.focus(); }
    plus.onclick = function () {
      var open = kiezer.hidden; kiezer.hidden = !open; plus.setAttribute("aria-expanded", open ? "true" : "false");
      if (open) { tekenKiezer(); tintStrook.focus({ preventScroll: true }); kiezer.scrollIntoView({ block: "nearest", behavior: "smooth" }); }
    };
    kiezer.querySelector('[data-kb-kiezer-weg]').onclick = kiezerDicht;
    kiezer.querySelector('[data-kb-kiezer-ja]').onclick = function () {
      var k = kiezerKleur();
      MIJN = [k].concat(MIJN.filter(function (x) { return x !== k; })).slice(0, MIJN_MAX);
      bewaarMijn(MIJN); verfTeken(); kiesKleur(k); kiezerDicht();
    };
    kiezer.addEventListener("keydown", function (ev) { if (ev.key === "Escape") kiezerDicht(); });

    /* Wijs je op de computer een plaatje in de rij aan, dan komt hij groot onder het plaatje, met de naam erbij (Carolien,
       22-10-2026: "als je met de muis over de miniaturen gaat ... kan je die dan ook vergroot laten zien"). Alleen met een
       muis; op een telefoon of tablet kies je gewoon door te tikken. */
    var groot = root.querySelector("[data-kb-groot]"), muis = window.matchMedia && window.matchMedia("(hover: hover) and (pointer: fine)").matches;
    function grootWeg() { groot.hidden = true; }
    PLATEN.forEach(function (pl, i) {
      var b = document.createElement("button"); b.type = "button"; b.setAttribute("aria-label", "Kleurplaat " + pl.naam);
      b.innerHTML = '<img src="' + pl.klein + '" alt="" loading="lazy">'; b.onclick = function () { grootWeg(); bewaarWerk(); plaatNu = i; laad(); };
      if (muis) {
        b.addEventListener("mouseenter", function () {
          groot.querySelector("img").src = pl.klein; groot.querySelector("span").textContent = pl.naam;
          var r = b.getBoundingClientRect(), breed = 340;
          groot.style.left = Math.max(8, Math.min(window.innerWidth - breed - 8, r.left + r.width / 2 - breed / 2)) + "px";
          groot.style.top = (r.bottom + 10) + "px";
          groot.hidden = false;
        });
        b.addEventListener("mouseleave", grootWeg);
      }
      keuze.appendChild(b);
    });
    window.addEventListener("scroll", grootWeg, { passive: true });
    keuze.addEventListener("scroll", grootWeg, { passive: true });
    root.querySelectorAll(".kb-kwasten [data-kwast]").forEach(function (b) { b.onclick = function () { kiesGereedschap(b.dataset.kwast); }; });

    /* Ongedaan maken (Carolien, 22-10-2026: "die knop is toch de laatste bewerking ongedaan maken"). Voor elke stap (een tik
       met de emmer, een streep met een kwast of de gum) onthouden we hoe het stuk dat veranderde eruitzag, per plaat de
       laatste twintig stappen. Alleen het veranderde stuk, anders wordt het te zwaar voor een telefoon. */
    var stappen = {}, voorStap = null, MAX_STAPPEN = 20, terugKnop = root.querySelector("[data-kb-terug]");
    function startStap() { voorStap = ctx && geladen === plaatNu ? ctx.getImageData(0, 0, c.width, c.height) : null; }
    function eindStap() {
      if (!voorStap || geladen !== plaatNu) { voorStap = null; return; }
      var oud = voorStap.data, nu = ctx.getImageData(0, 0, c.width, c.height).data, w = c.width;
      var x0 = w, x1 = -1, y0 = c.height, y1 = -1;
      voorStap = null;
      for (var i = 0; i < oud.length; i += 4) {
        if (oud[i] === nu[i] && oud[i + 1] === nu[i + 1] && oud[i + 2] === nu[i + 2]) continue;
        var px = (i >> 2) % w, py = ((i >> 2) / w) | 0;
        if (px < x0) x0 = px; if (px > x1) x1 = px; if (py < y0) y0 = py; if (py > y1) y1 = py;
      }
      if (x1 < 0) return;
      var bw = x1 - x0 + 1, bh = y1 - y0 + 1, stuk = new ImageData(bw, bh);
      for (var yy = 0; yy < bh; yy++) stuk.data.set(oud.subarray(((y0 + yy) * w + x0) * 4, ((y0 + yy) * w + x1 + 1) * 4), yy * bw * 4);
      var lijst = stappen[plaatNu] = stappen[plaatNu] || [];
      lijst.push({ x: x0, y: y0, stuk: stuk });
      if (lijst.length > MAX_STAPPEN) lijst.shift();
      zetTerug();
    }
    function zetTerug() { terugKnop.disabled = !(geladen === plaatNu && stappen[plaatNu] && stappen[plaatNu].length); }
    terugKnop.onclick = function () {
      var lijst = stappen[plaatNu];
      if (geladen !== plaatNu || !lijst || !lijst.length) return;
      var s = lijst.pop(); ctx.putImageData(s.stuk, s.x, s.y); loepTeken(); zetTerug();
    };

    /* Opnieuw: eerst de vraag of je echt opnieuw wilt beginnen; dan is de plaat wit en kun je niets meer terugzetten. */
    var vraag = root.querySelector("[data-kb-vraag]"), vraagVan = null;
    function vraagDicht() { vraag.hidden = true; if (vraagVan) vraagVan.focus(); }
    root.querySelectorAll("[data-kb-leeg]").forEach(function (k) {
      k.onclick = function () { vraagVan = k; vraag.hidden = false; vraag.querySelector("[data-kb-vraag-nee]").focus(); };
    });
    vraag.querySelector("[data-kb-vraag-nee]").onclick = vraagDicht;
    vraag.querySelector("[data-kb-vraag-ja]").onclick = function () { delete werk[plaatNu]; delete stappen[plaatNu]; vraagDicht(); laad(); };
    vraag.addEventListener("click", function (ev) { if (ev.target === vraag) vraagDicht(); });
    document.addEventListener("keydown", function (ev) { if (ev.key === "Escape" && !vraag.hidden) vraagDicht(); });
    root.querySelector('[data-kb-bewaar]').onclick = bewaar;
    function pos(ev) { var r = c.getBoundingClientRect(); return { x: (ev.clientX - r.left) * (c.width / r.width), y: (ev.clientY - r.top) * (c.height / r.height) }; }
    /* Kleuren gaat op de tekening en in het vergrootglas op dezelfde manier; in het glas is de kwast net zo dik als hij
       eruitziet, dus dunner op de tekening (daarom de schaal), zodat je de kleine stukjes netjes kunt kleuren. */
    var vorige = null, dikte = kwast;
    function begin(p, schaal) {
      startStap();
      if (gereedschap === "vul") { vulVlak(p.x, p.y); eindStap(); loepTeken(); return false; }
      dikte = kwast * BREED / 900 / schaal; vorige = p;
      ctx.fillStyle = gereedschap === "gum" ? "#ffffff" : kleurKleur; ctx.beginPath(); ctx.arc(p.x, p.y, dikte / 2, 0, Math.PI * 2); ctx.fill();
      loepTeken(); return true;
    }
    function beweeg(p) {
      ctx.strokeStyle = gereedschap === "gum" ? "#ffffff" : kleurKleur; ctx.lineWidth = dikte; ctx.lineCap = "round"; ctx.lineJoin = "round";
      ctx.beginPath(); ctx.moveTo(vorige.x, vorige.y); ctx.lineTo(p.x, p.y); ctx.stroke(); vorige = p;
      loepTeken();
    }
    c.addEventListener("pointerdown", function (ev) {
      ev.preventDefault();
      if (begin(pos(ev), 1)) { tekenen = true; c.setPointerCapture(ev.pointerId); }
    });
    c.addEventListener("pointermove", function (ev) { if (tekenen) beweeg(pos(ev)); });
    ["pointerup", "pointercancel", "pointerleave"].forEach(function (t) { c.addEventListener(t, function () { if (tekenen) eindStap(); tekenen = false; }); });

    /* Het vergrootglas (Caroliens ontwerp, 22-10-2026): het knopje onder de gum zet een rond glas op de tekening. In het
       glas zie je het stuk eronder groter (2x tot 8x, met + en - of met twee vingers) en kleur je met het gekozen
       gereedschap; dat komt meteen op de tekening. Schuiven aan het handvat of de gele rand; nog een tik op het knopje en
       het glas is weg. loepX en loepY zijn het midden van het glas, als deel van de tekening (0 tot 1). */
    var loepKnop = root.querySelector("[data-kb-loep]"), loep = root.querySelector("[data-kb-loep-glas]");
    var loepGlas = loep.querySelector(".kb-loep__glas"), loepDoek = loep.querySelector("canvas"), loepCtx = loepDoek.getContext("2d");
    var loepMaatTekst = loep.querySelector(".kb-loep__maat"), rooster = root.querySelector(".kb-rooster"), doek = root.querySelector(".kb-doek");
    var ZOOMS = [2, 3, 4, 6, 8], zoom = 3, loepX = 0.5, loepY = 0.5, lijnBeeld = null, loepTekent = false, vingers = {}, knijp = null;
    function loepPlaats() {
      var r = doek.getBoundingClientRect(), o = rooster.getBoundingClientRect();
      var d = Math.round(Math.max(150, Math.min(260, r.width * 0.46)));
      loep.style.width = loep.style.height = d + "px";
      loep.style.left = (r.left - o.left + loepX * r.width - d / 2) + "px";
      loep.style.top = (r.top - o.top + loepY * r.height - d / 2) + "px";
    }
    function loepTeken() {
      if (loep.hidden || !ctx) return;
      var g = loepDoek.getBoundingClientRect(), r = doek.getBoundingClientRect(), dpr = window.devicePixelRatio || 1;
      var px = Math.max(1, Math.round(g.width * dpr));
      if (loepDoek.width !== px) loepDoek.width = loepDoek.height = px;
      /* welk stuk van de tekening je ziet: het glas gedeeld door de zoom, rond het midden */
      var bw = g.width / zoom / r.width, bh = g.width / zoom / r.height, sx = loepX - bw / 2, sy = loepY - bh / 2;
      loepCtx.globalCompositeOperation = "source-over"; loepCtx.fillStyle = "#fff"; loepCtx.fillRect(0, 0, px, px);
      loepCtx.drawImage(c, sx * c.width, sy * c.height, bw * c.width, bh * c.height, 0, 0, px, px);
      if (lijnBeeld) {
        loepCtx.globalCompositeOperation = "multiply";
        loepCtx.drawImage(lijnBeeld, sx * lijnBeeld.naturalWidth, sy * lijnBeeld.naturalHeight, bw * lijnBeeld.naturalWidth, bh * lijnBeeld.naturalHeight, 0, 0, px, px);
        loepCtx.globalCompositeOperation = "source-over";
      }
      loepMaatTekst.textContent = (Math.round(zoom * 10) / 10) + "×";
    }
    function loepPunt(ev) {
      var g = loepDoek.getBoundingClientRect(), r = doek.getBoundingClientRect();
      var fx = loepX + (ev.clientX - g.left - g.width / 2) / zoom / r.width, fy = loepY + (ev.clientY - g.top - g.height / 2) / zoom / r.height;
      return { x: fx * c.width, y: fy * c.height };
    }
    function zoomNaar(z) { zoom = Math.max(ZOOMS[0], Math.min(ZOOMS[ZOOMS.length - 1], z)); loepTeken(); }
    function loepAan(aan) {
      loep.hidden = !aan; loepKnop.setAttribute("aria-pressed", aan ? "true" : "false");
      if (aan) { loepPlaats(); loepTeken(); }
    }
    loepKnop.onclick = function () { loepAan(loep.hidden); };
    loep.querySelector("[data-kb-loep-plus]").onclick = function () { zoomNaar(ZOOMS.filter(function (z) { return z > zoom + 0.01; })[0] || zoom); };
    loep.querySelector("[data-kb-loep-min]").onclick = function () { zoomNaar(ZOOMS.filter(function (z) { return z < zoom - 0.01; }).pop() || zoom); };
    /* kleuren in het glas, en met twee vingers knijpen om in en uit te zoomen */
    loepDoek.addEventListener("pointerdown", function (ev) {
      ev.preventDefault(); ev.stopPropagation(); loepDoek.setPointerCapture(ev.pointerId);
      vingers[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
      var ids = Object.keys(vingers);
      if (ids.length === 2) {
        if (loepTekent) eindStap();
        loepTekent = false;
        var a = vingers[ids[0]], b = vingers[ids[1]]; knijp = { afstand: Math.hypot(a.x - b.x, a.y - b.y) || 1, zoom: zoom };
        return;
      }
      loepTekent = begin(loepPunt(ev), zoom);
    });
    loepDoek.addEventListener("pointermove", function (ev) {
      if (!vingers[ev.pointerId]) return;
      vingers[ev.pointerId] = { x: ev.clientX, y: ev.clientY };
      var ids = Object.keys(vingers);
      if (knijp && ids.length === 2) { var a = vingers[ids[0]], b = vingers[ids[1]]; zoomNaar(knijp.zoom * Math.hypot(a.x - b.x, a.y - b.y) / knijp.afstand); return; }
      if (loepTekent) beweeg(loepPunt(ev));
    });
    ["pointerup", "pointercancel"].forEach(function (t) {
      loepDoek.addEventListener(t, function (ev) { delete vingers[ev.pointerId]; if (Object.keys(vingers).length < 2) knijp = null; if (loepTekent) eindStap(); loepTekent = false; });
    });
    /* schuiven: aan het handvat of de gele rand (niet in het glas zelf, daar kleur je) */
    function schuifbaar(el) {
      var greep = null;
      el.addEventListener("pointerdown", function (ev) {
        if (ev.target === loepDoek) return;
        ev.preventDefault(); el.setPointerCapture(ev.pointerId);
        greep = { x: ev.clientX, y: ev.clientY, lx: loepX, ly: loepY };
      });
      el.addEventListener("pointermove", function (ev) {
        if (!greep) return;
        var r = doek.getBoundingClientRect();
        loepX = Math.max(0, Math.min(1, greep.lx + (ev.clientX - greep.x) / r.width));
        loepY = Math.max(0, Math.min(1, greep.ly + (ev.clientY - greep.y) / r.height));
        loepPlaats(); loepTeken();
      });
      ["pointerup", "pointercancel"].forEach(function (t) { el.addEventListener(t, function () { greep = null; }); });
    }
    schuifbaar(loep.querySelector("[data-kb-loep-steel]")); schuifbaar(loepGlas);
    window.addEventListener("resize", function () { if (!loep.hidden) { loepPlaats(); loepTeken(); } });
    c.addEventListener("keydown", function (ev) { if ((ev.key === "Enter" || ev.key === " ") && gereedschap === "vul") { ev.preventDefault(); startStap(); vulVlak(c.width / 2, c.height / 2); eindStap(); } });
    kiesGereedschap("vul"); laad();
  }
  function alles() { document.querySelectorAll('[data-kleurboek]').forEach(function (r) { if (!r.dataset.kbKlaar) { r.dataset.kbKlaar = "1"; start(r); } }); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", alles); else alles();
  document.addEventListener("shopify:section:load", alles);
})();
